import styled from 'styled-components'

import { UserShort } from '@root/entities/user-short'
import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'
import { ProfileLink } from '@root/features/profile'
import { useAppRoutes } from '@root/features/routing'
import { Skeleton } from '@root/shared/ui-kit'

import { FollowUserButton } from '../../../activity-actions'
import { ActivityKebabActions } from '../../../activity-actions/activity-kebab-actions'

import type { FollowerDetail } from '@root/entities/follower-detail'

interface UserConnectionsFollowerModalProps {
  follower: FollowerDetail.FollowerDetail
  onNavigateToProfile: () => void
}
export const UserConnectionsFollowerModal = ({
  follower,
  onNavigateToProfile,
}: UserConnectionsFollowerModalProps) => {
  const { navigateUserProfile } = useAppRoutes()

  const handleNavigateToUserProfile = () => {
    onNavigateToProfile()
    navigateUserProfile(follower.delugeId)
  }

  const name = UserShort.someName(follower)

  return (
    <Root>
      <UserProfile>
        <div>
          <ProfileLink
            delugeId={follower.delugeId}
            onClick={() => onNavigateToProfile()}
          >
            {<UserShortAvatar withPreview size={24} userShort={follower} />}
          </ProfileLink>
        </div>
        {name ? (
          <ProfileLink
            delugeId={follower.delugeId}
            onClick={() => onNavigateToProfile()}
          >
            <Name>{name}</Name>
          </ProfileLink>
        ) : undefined}
      </UserProfile>

      <Right>
        <FollowUserButton
          delugeId={follower.delugeId}
          variant="soft"
          size="xs"
          radius="rounded"
          type="button"
        />
        <ActivityKebabActions
          size="xs"
          userShort={follower}
          onNavigateToUserProfile={handleNavigateToUserProfile}
        />
      </Right>
    </Root>
  )
}

const Root = styled.div`
  padding: 12px 14px;
  gap: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--appearanceA-2);
  border-radius: 10px;
  align-items: center;
`

const UserProfile = styled.div`
  color: var(--text-12);

  gap: 8px;
  display: flex;
  align-items: center;
`

const Right = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  word-break: break-word;
`
const Name = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  text-wrap: balance;
  color: var(--appearance-inv-1);
`

const Skeleton_ = () => (
  <Root>
    <UserProfile>
      <div>
        <Skeleton variant={'circular'} width={24} height={24} />
      </div>
      <Name>
        <Skeleton.Line width={90} />
      </Name>
    </UserProfile>
    <Right>
      <UnfollowSkeleton>
        <Skeleton.Surface />
      </UnfollowSkeleton>

      <KebabSkeleton>
        <Skeleton.Surface />
      </KebabSkeleton>
    </Right>
  </Root>
)

UserConnectionsFollowerModal.Skeleton = Skeleton_
const UnfollowSkeleton = styled.div`
  width: 62px;
  height: 32px;
  position: relative;
`
const KebabSkeleton = styled.div`
  width: 32px;
  height: 32px;
  position: relative;
`
